import plugin from "tailwindcss/plugin.js";
const indicators = ["dividend", "earnings"];
/**
 * This plugin is based on a 3rd party library. I recreated a limited version of the functionality here
 * that is slightly more tailored to our needs - https://github.com/gvital3230/tailwindcss-tooltip-arrow-after.
 */
export default plugin(({ addUtilities }) => {
    addUtilities(indicators.map((indicator) => ({
        [`.indicator-arrow-${indicator}-left`]: {
            backgroundColor: `var(--color-background-indicator-${indicator})`,
            position: "relative",
            "&:before, &:after": {
                content: '""',
                position: "absolute",
                top: "0",
                left: "-15px",
                borderTop: "7.5px solid transparent",
                borderRight: `7.5px solid var(--color-background-indicator-${indicator})`,
                borderBottom: "7.5px solid transparent",
                borderLeft: "7.5px solid transparent",
            },
            "&:after": {
                borderRight: `7.5px solid var(--color-background-indicator-${indicator})`,
                left: "-15px",
            },
        },
        [`.indicator-arrow-${indicator}-right`]: {
            backgroundColor: `var(--color-background-indicator-${indicator})`,
            position: "relative",
            "&:before, &:after": {
                content: '""',
                position: "absolute",
                top: "0px",
                right: "-15px",
                borderTop: "7.5px solid transparent",
                borderRight: "7.5px solid transparent",
                borderBottom: "7.5px solid transparent",
                borderLeft: `7.5px solid var(--color-background-indicator-${indicator})`,
            },
            "&:after": {
                borderLeft: `7.5px solid var(--color-background-indicator-${indicator})`,
                right: "-15px",
            },
        },
    })));
});
